import { Form } from 'react-final-form'

import { CepIntegration, PayloadCepIntegration } from 'common/api'
import Modal from 'common/components/Modal'
import { ProjectMappedUiFields } from 'common/interfaces/projects'

import { CepTemplateFormatted } from '../../../api/queries/useGetCepIntegrationTemplatesQuery'

import CreateCepIntegrationWidget from './CreateCepIntegrationWidget'

type Props = {
  cep: CepTemplateFormatted
  onClose: () => void
  onSubmit: (payload: PayloadCepIntegration) => void
  integrationToUpdate?: CepIntegration
  isCreateWidgetVisible: boolean
}

const CreateCepIntegrationModal = ({
  cep,
  onClose,
  isCreateWidgetVisible,
  onSubmit,
  integrationToUpdate,
}: Props) => {
  return (
    <div className="bg-gold-40 flex-grow">
      <Form<ProjectMappedUiFields>
        onSubmit={() => {}}
        render={() => (
          <>
            <Modal
              centered
              closable={false}
              footer={null}
              hasMargin={false}
              visible={isCreateWidgetVisible}
            >
              <CreateCepIntegrationWidget
                cepTemplate={cep}
                onClose={onClose}
                onSubmit={onSubmit}
                integrationToUpdate={integrationToUpdate}
              />
            </Modal>
          </>
        )}
      />
    </div>
  )
}

export default CreateCepIntegrationModal
